/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BetreuungsverhaeltnisInputs */

const de__field_betreuungsverhaeltnis = /** @type {(inputs: _Field_BetreuungsverhaeltnisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreueungsverhältnis`)
};

/**

* @param {_Field_BetreuungsverhaeltnisInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_betreuungsverhaeltnis = /** @type {((inputs?: _Field_BetreuungsverhaeltnisInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BetreuungsverhaeltnisInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_betreuungsverhaeltnis(inputs)
});